import { KILO } from '../../constants/KILO_THEME'

type StatusPillProps = {
  label: string
  active?: boolean
  onClick?: () => void
}

const StatusPill = ({ label, active = false, onClick }: StatusPillProps) => {
  const base = `px-2.5 py-0.5 text-xs ${KILO.radius.pill} transition-colors`
  const style = active ? `${KILO.pill.active} ${base}` : `${KILO.pill.inactive} ${base}`

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={`${style} min-h-8`}>
        {label}
      </button>
    )
  }

  return <span className={style}>{label}</span>
}

export default StatusPill
